// extracted by mini-css-extract-plugin
export default {"marginBottom2":"error-page_marginBottom2__aRh+-","marginBottom4":"error-page_marginBottom4__ozV9Z","error":"error-page_error__wFeMk"};